import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const api = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['List', 'Request', 'Resources', 'User', 'Amendments', 'UserGroups'],
  endpoints: () => ({}),
});
